import { useMutation } from '@apollo/client';
import checkinGraph from '../../graphql-queries/checkin';

export function useCreateWeather() {
  return useMutation(checkinGraph.CREATE_WEATHER);
}
